<template>
    <v-card>
        <v-card-title class="pt-6 pb-4" >
            <v-icon style="background: #e7e8e9; padding: 10px!important; border-radius: 50%;" class="mr-4"> mdi-calendar</v-icon>
            <span>Nuevo Anuncio</span>
            <v-spacer/>
            <v-autocomplete
              :rules="[rules.required]"
              v-model="calendar.influencerIds"
              :items="influencerItems"
              :loading="isLoadingInfluencers"
              :search-input.sync="searchInfluencers"
              hide-no-data
              item-value="id"
              item-text="name"
              label="Influencer(s)"
              placeholder="Escribe para buscar"
              clearable
              multiple
              small-chips
            >
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.name }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.extra">{{ item.extra }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
            <v-container>
                <v-row class="ma-0">
                    <v-col cols="3">
                        <v-autocomplete :rules="[v => !!v || 'Campo requerido']" clearable v-model="calendar.activity_type_id" :items="activityLists" label="Tipo" item-text="name" item-value="id">
                            <template slot="no-data">No existen actividades relacionadas.</template>                      
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="9">
                        <v-text-field label="Titulo" v-model="calendar.title"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="ma-0">
                    <v-col class="py-0" cols="12" sm="6" md="6">
                        <v-menu v-model="datePicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                            <template v-slot:activator="{ on }">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" clearable required v-model="calendar.only_date" label="Fecha" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                            </template>
                            <v-date-picker color="primary" v-model="calendar.only_date" @input="datePicker = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="6" md="6">
                        <v-autocomplete clearable v-model="calendar.only_time" prepend-icon="mdi-clock-outline" :items="hours" label="Hora">               
                        </v-autocomplete>
                    </v-col>  
                </v-row>  
                <vue-editor
                    use-custom-image-handler
                    @image-added="handleImageAdded"
                    v-model="calendar.description"
                    :editorOptions="editorSettings"
                    :editor-toolbar="customToolbar"
                    >
                </vue-editor>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-menu top offset-x class="hidden-md-and-down">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn style="font-size:12px;" text v-bind="attrs" v-on="on" :color="fileColor(calendar.featured_image)">
                        <v-icon class="mr-2">mdi-attachment</v-icon> Imagen Destacada
                    </v-btn>
                </template>
                <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot="true" v-on:vdropzone-success="uploadSuccess" v-on:vdropzone-error="uploadError" v-on:vdropzone-removed-file="fileRemoved"/>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
                Cancelar
            </v-btn>
            <v-btn color="blue darken-1" :loading="gris" :disabled="gris" text @click="save">
                Guardar
            </v-btn>
        </v-card-actions>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show">
            {{ snackbar.message }}
        </v-snackbar>
    </v-card>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import { VueEditor,Quill } from 'vue2-editor';
import ImageResize from 'quill-image-resize-vue';
import { ImageDrop } from 'quill-image-drop-module';

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
import axios from "axios";
    export default {
        components: { 
            VueEditor,
            vueDropzone: vue2Dropzone,
        },
        data: () => ({
            searchInfluencers: '',
            isLoadingInfluencers: false,
            influencers: [],
            snackbar: {
                show: false,
                message: null,
                color: null
            },
            gris:false,
            timePicker:'',
            datePicker:'',
            calendar:{
                activity_type_id:'',
                date:'',
                only_date:new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(0,10),
                only_time:new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(11,14) + (new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(14,16)<15?'00':new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(14,16)<30?15:new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(14,16)<45?30:45) + ':00',
                description:'',
                user_id:'',
                title:'',
                featured_image:'',
                influencerIds:[]
            },
            rules: {
                required: value => !!value || 'Campo requerido',
            },
            customToolbar: [
                [{ 'font': [] }],
                [{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
                [{ 'size': ['small', false, 'large', 'huge'] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
                //[{ 'header': 1 }, { 'header': 2 }],
                ['blockquote', 'code-block'],
                [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                [{ 'script': 'sub'}, { 'script': 'super' }],
                [{ 'indent': '-1'}, { 'indent': '+1' }],
                [{ 'color': [] }, { 'background': [] }],
                ['link', 'image', 'video', 'formula'],
                [{ 'direction': 'rtl' }],
                ['clean'],
            ],
            editorSettings: {
                modules: {
                    imageDrop: true,
                    imageResize: {},
                }
            },
            dropzoneOptions: {
                url: process.env.VUE_APP_BACKEND_ROUTE + "api/v1/sale/file",
                addRemoveLinks: true,
                maxFiles: 1
            },
            fileName:'',
        }),
        watch: {
            searchInfluencers (val) {
            if (this.isLoadingInfluencers) return
            this.isLoadingInfluencers = true
            const base = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer/search?'
            const url  = base + 'filter[social_networks]=' + encodeURIComponent(val || '')
            this.$nextTick(() => {
                axios.get(url)
                .then(res => {
                    this.influencers = (res && res.data && res.data.data) ? res.data.data : []
                })
                .finally(() => { this.isLoadingInfluencers = false })
            })
            }
        },
        computed: {
            influencerItems () {
                const list = this.influencers || []
                return list.map(function (i) {
                    return {
                    id: i.id,
                    name: (i.social_networks && i.social_networks.instagram) ? i.social_networks.instagram : (i.name || ('#' + i.id)),
                    extra: i.name && i.last ? (i.name + ' ' + i.last) : (i.name || '')
                    }
                })
            },
            currentUser:{
                get(){
                    return this.$store.state.currentUser.user;
                }
            },
            valid(){
                if(
                    (this.calendar.activity_type_id!=''&&this.calendar.activity_type_id!=undefined&&this.calendar.activity_type_id!=null)&&
                    (this.calendar.only_date!=''&&this.calendar.only_date!=undefined&&this.calendar.only_date!=null)&&
                    (this.calendar.only_time!=''&&this.calendar.only_time!=undefined&&this.calendar.only_time!=null)&&
                    (this.calendar.user_id!=''&&this.calendar.user_id!=undefined&&this.calendar.user_id!=null)
                ){
                    return false
                }else{
                    return true
                }
            },
            hours(){
                var arr = [], i, j;
                for(i=0; i<24; i++) {
                    for(j=0; j<4; j++) {
                        arr.push(this.cero(i) + ":" + (j===0 ? "00" : 15*j) + ":00");
                    }
                }
                return arr
            },
            activityLists(){
                return this.$store.state.activity.activities;
            },  
            usersLists(){
                return this.$store.state.user.users;
            }
        },
        methods: {
            fileColor(item){
                if(item!=''&&item!=undefined&&item!=null){
                    return 'success'
                }
            },
            uploadSuccess(file, response) {
                this.fileName = file;
                this.calendar.featured_image = response.file;
            },
            uploadError(file, message) {
                console.log('An Error Occurred');
            },
            fileRemoved() {
                this.calendar.featured_image = ''
            },
            cero(i){
                if(i<10){
                    return '0' + i
                }else{
                    return i
                }
            },
            close () {
                this.calendar = Object.assign({}, this.defaultItem)
                this.gris = false
                if(this.fileName != ''){
                    this.$refs.myVueDropzone.removeFile(this.fileName)
                    this.fileName = ''
                }
                this.$nextTick(() => {
                    this.$emit("closeCreateDialogCalendar", false);
                })
            },
            save(){
                this.gris = true
                this.calendar.user_id = this.currentUser.id
                this.calendar.date = this.calendar.only_date + ' ' + this.calendar.only_time
                this.$nextTick(() => {
                    axios.post(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/activities",Object.assign(this.calendar)).then(response=>{
                        this.close()
                    }).catch(error => {
                        this.snackbar = {
                            message: error.response.data.message,
                            color: 'error',
                            show: true
                        }
                        this.gris = false
                    })
                })
            },
            handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
                var formData = new FormData();
                formData.append("file", file);
                axios({
                    url: process.env.VUE_APP_BACKEND_ROUTE + "api/v1/sale/file",
                    method: "POST",
                    data: formData,
                })
                .then(response => {
                    const url = 'https://unopack.mx/files/' + response.data.file
                    Editor.insertEmbed(cursorLocation, "image", url);
                    resetUploader();
                })
                .catch(err => {
                    this.snackbar = {
                        message: err,
                        color: 'error',
                        show: true
                    }
                });
            },
        },
}
</script>
<style lang="css" scoped>
.v-text-field >>> label{
    font-size: 14px!important;
}
</style>
<style>
.v-input__icon--prepend-inner i::before {
    font-size: 18px!important;
    color:#1976D2;
}
.v-text-field input, .v-label {
    font-size: 14px;
}
.v-picker__title.primary{
    display:none;
}
</style>